import React from "react"
import { Link } from "gatsby"
import Children from "react-children-utilities"

export const RecommendedPostBlockquote = ({ content, text }) => {
  const image_DOM_node = Children.filter(
    content,
    ({ type }) => type === "figure"
  )[0]
  const link_node = Children.filter(content, ({ type }) => type === "a")[0]
  const link = link_node.props.href
  const title_DOM_node = link_node.props.children

  return (
    <React.Fragment>
      <div className="section p-0 my-5">
        <Link to={link} className="p-0">
          <div className="columns is-gapless">
            <div className="column is-4 m-auto recommended-blogpost-thumbnail">
              {image_DOM_node}
            </div>
            <div className="column">
              <div className="pt-5 px-5">
                <p className="title is-5 has-text-mitternachtsblau">
                  {title_DOM_node}
                </p>
                <p className="has-text-mitternachtsblau pb-5">
                  {text}
                  <br />➨ <span className="link is-semi-shy">Mehr lesen</span>
                </p>
              </div>
            </div>
          </div>
        </Link>
      </div>
      <hr className="has-background-mitternachtsblau is-slim" />
    </React.Fragment>
  )
}
